import { RefObject, useCallback } from "react";

import useStickyRow from "ds/components/Table/hooks/useStickyRow";
import { TableColumnMeta } from "ds/components/Table/types";
import { VcsProvider } from "types/generated";

import { ModulePullRequestsTableRow } from "../gql";
import ModulePullRequestsTableRowPullRequest from "./Row/PullRequest";

type ModulePullRequestsTableStickyParentRowProps = {
  pullRequest: ModulePullRequestsTableRow;
  moduleId: string;
  moduleProvider: VcsProvider;
  isExpanded: boolean;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  keyboardProps: Record<string, unknown>;
  measureRef: (node: HTMLDivElement | null) => void;
  dataIndex: number;
  isActiveSticky: boolean;
  nextAfterSticky?: number;
  tableRef: RefObject<HTMLDivElement | null>;
};

const ModulePullRequestsTableStickyParentRow = ({
  pullRequest,
  moduleId,
  moduleProvider,
  isExpanded,
  columns,
  isFirstColumnPinned,
  keyboardProps,
  measureRef,
  dataIndex,
  isActiveSticky,
  nextAfterSticky,
  tableRef,
}: ModulePullRequestsTableStickyParentRowProps) => {
  const rowRef = useStickyRow(isActiveSticky, nextAfterSticky, tableRef);

  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      measureRef(node);
      rowRef.current = node;
    },
    [measureRef, rowRef]
  );

  return (
    <ModulePullRequestsTableRowPullRequest
      pullRequest={pullRequest}
      moduleId={moduleId}
      moduleProvider={moduleProvider}
      columns={columns}
      isFirstColumnPinned={isFirstColumnPinned}
      keyboardProps={keyboardProps}
      measureRef={setRef}
      dataIndex={dataIndex}
      isGroupOpen={isActiveSticky}
      isExpanded={isExpanded}
    />
  );
};

export default ModulePullRequestsTableStickyParentRow;
